import { render, staticRenderFns } from "./DeptIssueReport.vue?vue&type=template&id=f62a9d10&scoped=true"
import script from "./DeptIssueReport.vue?vue&type=script&lang=js"
export * from "./DeptIssueReport.vue?vue&type=script&lang=js"
import style0 from "./DeptIssueReport.vue?vue&type=style&index=0&id=f62a9d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62a9d10",
  null
  
)

export default component.exports